import events from 'eventslibjs'

export default function (dom, opts) {
	var options = {
		headerSel: ".header__container",
		openCls: "header__container--active",
		bodyOpenCls: "nav-open",
		openTrigger: "[data-navigation-toggle]",
		closeTrigger: "[data-navigation-close]",
		subnavSel: ".nav-main__single",
		subnavCls: "nav-main__single--open",
		//TODO: this is a complicated selector, there must be another way
		subnavTrigger: ".level_1 > .nav-main__single > a, .level_1 > .nav-main__single > span",
		subnavCloseTrigger: "[data-navigation-subnav-close]",

		...opts
	}

	init()

	function init() {
		events.on('touchend', options.openTrigger, onOpen)
		//events.on('click', options.subnavTrigger, onSubnavOpen)
		events.on('click', options.subnavCloseTrigger, onSubnavClose)
	}

	function onOpen() {
		if (!getNavigationContainer().classList.contains(options.openCls)) {
			getNavigationContainer().classList.add(options.openCls)
			getBody().classList.add(options.bodyOpenCls)
			getNavigationToggle().setAttribute("aria-expanded", true)
			events.on('touchend.outer', document, onOuterClick )
		} else {
			onClose()
		}
	}
	function onClose() {
		// toggle
		getNavigationContainer().classList.remove(options.openCls)
		getBody().classList.remove(options.bodyOpenCls)
		getNavigationToggle().setAttribute("aria-expanded", false)
		onSubnavClose()
		events.off('touchend.outer', document, onOuterClick )
	}
	function onOuterClick(e) {
		if (!getNavigationContainer().contains(e.target)) {
			onClose()
		}
	}
/*	function onSubnavOpen(e) {
		let nav = e.target.parentElement.parentElement

		if (nav && !nav.classList.contains(options.subnavCls)) {
			e.preventDefault()
			nav.classList.add(options.subnavCls)
		} else {
			onSubnavClose(nav, e.target)
		}
	}*/
	function onSubnavClose() {
		dom.querySelectorAll("." + options.subnavCls).forEach(node => {
			node.classList.remove(options.subnavCls)
		})
	}
	function getNavigationContainer() {
		return dom.querySelector(options.headerSel)
	}
	function getSubnav() {
		return dom.querySelector(options.subnavSel)
	}
	function getNavigationToggle() {
		return dom.querySelector(options.openTrigger)
	}
	function getBody() {
		return document.body
	}
}